import { clusterApiUrl } from '@solana/web3.js';

export type Network = 'mainnet-beta' | 'devnet';

export const NETWORK_STORAGE_KEY = 'botcortex_network';
export const NETWORK_ADMIN_OVERRIDE_KEY = 'botcortex_network_admin';

export function getDefaultNetwork(): Network {
  if (typeof window === 'undefined') {
    const env = import.meta.env.VITE_SOLANA_NETWORK;
    return env === 'devnet' ? 'devnet' : 'mainnet-beta';
  }

  // Only apply stored network after admin toggle (Ctrl+Shift+E)
  if (localStorage.getItem(NETWORK_ADMIN_OVERRIDE_KEY) === 'true') {
    const stored = localStorage.getItem(NETWORK_STORAGE_KEY);
    if (stored === 'devnet' || stored === 'mainnet-beta') {
      return stored;
    }
  }

  return 'mainnet-beta';
}

function extractApiKey(url: string): string | null {
  const match = url.match(/[?&]api-key=([^&]+)/);
  return match?.[1] ?? null;
}

function getHeliusDevnetRpcUrl(): string | null {
  const configured = import.meta.env.VITE_RPC_URL_DEVNET?.trim();
  if (configured?.startsWith('http')) {
    return configured;
  }

  const devnetKey = import.meta.env.VITE_HELIUS_API_KEY_DEVNET?.trim();
  if (devnetKey) {
    return `https://devnet.helius-rpc.com/?api-key=${devnetKey}`;
  }

  const sharedKey = import.meta.env.VITE_HELIUS_API_KEY?.trim();
  if (sharedKey) {
    return `https://devnet.helius-rpc.com/?api-key=${sharedKey}`;
  }

  const mainnetKey = extractApiKey(import.meta.env.VITE_RPC_URL_MAINNET?.trim() || '');
  if (mainnetKey) {
    return `https://devnet.helius-rpc.com/?api-key=${mainnetKey}`;
  }

  return null;
}

export function getRpcUrlForNetwork(network: Network): string {
  if (network === 'devnet') {
    return getHeliusDevnetRpcUrl() || clusterApiUrl('devnet');
  }
  return import.meta.env.VITE_RPC_URL_MAINNET || clusterApiUrl('mainnet-beta');
}
